import React from "react";
import "./styles.scss";

interface IProps {
	telegramName: string;
	changeTelegram: (name: string) => any;
}

interface IState {
	telegramName: string;
}

class ChatFormTelegram extends React.Component<IProps, IState> {
	state = {
		telegramName: this.props.telegramName,
	};

	changeTelegramName(value: string) {
		this.setState({
			...this.state,
			telegramName: value,
		})
	}

	sendTelegramName() {
		this.props.changeTelegram(this.state.telegramName);
	}

	deleteTelegramName() {
		this.changeTelegramName('');
		this.props.changeTelegram('');
	}

	get isDisabled() {
		return !this.state.telegramName || this.state.telegramName === this.props.telegramName;
	}

	render() {
		return (
			<div className={'phrase-container chat-form-telegram'}>
				<span>Ваш логин в Telegram</span>
				<div className={'chat-form-telegram__flex'}>
					<input value={this.state.telegramName ?? ''} type={'text'} onChange={event => this.changeTelegramName(event.currentTarget.value)}/>
					<input disabled={this.isDisabled} type={'button'} value={'Сохранить'} onClick={() => this.sendTelegramName()}/>
					<input type={'button'} value={'Удалить'} onClick={() => this.deleteTelegramName()}/>
				</div>
				{
					!this.props.telegramName
						? (
							<div className={'chat-form-telegram__label'}>
								<span className={'edit-phrase__label'}>Необходимо заполнить это поле, чтобы ваши сообщения из Telegram отправлялись клиенту</span>
							</div>
						)
						: ''
				}

			</div>
		)
	}
}

export default ChatFormTelegram;